import { Link } from "react-router-dom";
import "./terms.scoped.scss";

const Terms = ({ lang }) => (lang === "PL" ? TermsPl() : EnglishUnavailable());

const TermsPl = () => {
    return (
        <div>
            <section className="big">
                <h1>Zasady i warunki</h1>
                <p>Ostatnia aktualizacja: 27 lipiec 2022 r.</p>
                <p>Prosimy o uważne zapoznanie się z niniejszymi warunkami przed skorzystaniem z usługi.</p>
            </section>

            <section>
                <h1>Interpretacje i definicje</h1>
                <h2>Interpretacje</h2>
                <p>
                    Słowa pisane wielką literą, mają znaczenie zdefiniowane w następujących warunkach. Poniższe definicje
                    mają to samo znaczenie niezależnie od tego, w jakiej występują liczbie, przypadku lub rodzaju.
                </p>
                <h2>Definicje</h2>
                <p>Na potrzeby niniejszego regulaminu:</p>
                <ul>
                    <li>
                        <p>
                            <strong>AGM</strong> (określane w niniejszym regulaminie też jako &quot;My&quot;, &quot;Nas&quot;
                            lub &quot;Nasz&quot;) odnosi się do podmiotu zarządzającego/autora gry on-line Airlines Group
                            Manager.
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong>Usługa</strong> (zwana także &quot;Stroną internetową&quot; lub &quot;Grą&quot; ) odnosi
                            się do gry on-line Airlines Group Manager (w skrócie AGM), dostępnej pod adresem{" "}
                            <Link to="/" rel="nofollow noopener noreferrer" target="_blank">
                                https://wiktorgolicz.pl/AirlinesGroupManager
                            </Link>
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong>Zasady oraz warunki</strong> (nazywane również &quot;Warunkami&quot;) oznaczają niniejsze
                            Warunki, które stanowią całość umowy między Tobą a AGM.
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong>Usługa mediów społecznościowych osób trzecich</strong> oznacza wszelkie usługi lub treści
                            (w tym dane, informacje, produkty lub usługi) dostarczane przez osoby trzecie, które mogą być
                            wyświetlane, dołączane lub udostępniane przez Usługę.
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong>Użytkownik</strong> oznacza osobę uzyskującą dostęp do Usługi lub korzystającą z niej,
                            firmę lub inny podmiot prawny, w imieniu którego taka osoba uzyskuje dostęp lub korzysta z
                            Usługi, w zależności od przypadku.
                        </p>
                    </li>
                </ul>
            </section>

            <section>
                <h1>Potwierdzenie</h1>
                <p>
                    Są to Warunki regulujące korzystanie z tej Usługi oraz umowa, która obowiązuje między Tobą a AGM.
                    Niniejszy Regulamin określa prawa i obowiązki wszystkich użytkowników w zakresie korzystania z Serwisu.
                </p>
                <p>
                    Twój dostęp do Usługi i korzystanie z niej jest uwarunkowane akceptacją i przestrzeganiem niniejszych
                    Warunków. Niniejsze Warunki mają zastosowanie do wszystkich odwiedzających, użytkowników i innych osób,
                    które uzyskują dostęp do Usługi lub korzystają z niej.
                </p>
                <p>
                    Uzyskując dostęp lub korzystając z Usługi, wyrażasz zgodę na przestrzeganie niniejszych Warunków. Jeśli
                    nie zgadzasz się z jakąkolwiek częścią niniejszych Warunków, nie możesz uzyskać dostępu do Usługi.
                </p>
                <p>
                    Twój dostęp do Usługi i korzystanie z niej jest również uzależnione od Twojej akceptacji i przestrzegania
                    naszej Polityki Prywatności, która opisuje zasady i procedury dotyczące gromadzenia, wykorzystywania i
                    ujawniania Twoich danych osobowych podczas korzystania z Airlines Group Manager oraz informuje o Twoich
                    prawach do prywatności oraz o tym, jak prawo Cię chroni. Prosimy o uważne zapoznanie się z naszą Polityką
                    prywatności przed skorzystaniem z naszej usługi.
                </p>
            </section>

            <section>
                <h1>Opis i założenia usługi</h1>
                <h2>Opis usługi</h2>
                <p>
                    Airlines Group Manager to rozrywkowa gra on-line. Jej głównym i zarazem jedynym zadaniem jest rozrywka
                    dla graczy którzy są zainteresowani grą. Usługa jest bezpłatna i nie posiada reklam, lecz AGM zastrzega
                    sobie prawo do możliwości wprowadzenia takowych w przyszłości.
                </p>

                <h2>Założenia usługi</h2>
                <p>
                    Wszystkie zasoby wewnątrz gry są wyłącznie cyfrowe i AGM nie zobowiązuje się wypłacać ani wydawać żadnych
                    zasobów zgromadzonych w grze pod jakąkolwiek postacią.
                </p>
            </section>

            <section>
                <h1>Zasady korzystania z usługi</h1>
                <ol>
                    <li>Korzystanie z wielu kont jest dozwolone jedynie za wiedzą i zgodą administratora lub autora gry.</li>
                    <li>
                        Korzystanie z błędów i niedopatrzeń autora/autorów gry by osiągnąć jakąkolwiek przewagę nad innymi
                        graczami lub podejmowanie działań które za takowe mogą zostać uznane jest niedozwolone.
                    </li>
                    <li>
                        Używanie wulgaryzmów, pornografii i fraz obrażających lub mogących obrazić innych użytkowników jest
                        niedozwolone w żadnym miejscu w usłudze.
                    </li>
                    <li>Używanie jakiejkolwiek automatyzacji poza tą bezpośrednio dostępną w usłudze jest niedozwolone.</li>
                </ol>

                <p>
                    Podczas gdy pracujemy nad usunięciem wszystkich błędów i niedopatrzeń z naszej usługi, nie jesteśmy w
                    stanie usunąć ich wszystkich. Jeśli znajdziesz jakikolwiek błąd, prosimy byś zgłosił go nam na adres:{" "}
                    <a href="mailto: bugsAGM@wiktorgolicz.pl">bugsAGM@wiktorgolicz.pl</a> . Za zgłoszenie błędu, gracz może
                    otrzymać nagrodę w postaci punktów w grze.
                </p>
            </section>

            <section>
                <h1>Linki do innych stron internetowych lub usług</h1>
                <p>
                    Nasza Usługa może zawierać łącza do stron internetowych lub usług stron trzecich, które nie są własnością
                    ani nie są kontrolowane przez AGM.
                </p>
                <p>
                    AGM nie ma kontroli nad treścią, polityką prywatności ani praktykami stron internetowych lub usług stron
                    trzecich i nie ponosi za nie odpowiedzialności. Ponadto przyjmujesz do wiadomości i zgadzasz się, że AGM
                    nie ponosi odpowiedzialności, bezpośrednio ani pośrednio, za jakiekolwiek szkody lub straty spowodowane
                    lub rzekomo spowodowane przez lub w związku z wykorzystaniem lub poleganiem na takich treściach, towarach
                    lub usługach dostępnych na lub za pośrednictwem takich witryn internetowych lub usług.
                </p>
                <p>
                    Zdecydowanie zalecamy zapoznanie się z warunkami i polityką prywatności wszelkich odwiedzanych witryn
                    internetowych lub usług stron trzecich.
                </p>
            </section>

            <section>
                <h1>Rozwiązanie</h1>
                <p>
                    AGM zastrzega sobie prawo do natychmiastowego zakończenia lub zawieszenia twojego dostępu do usługi, bez
                    uprzedniego powiadomienia lub odpowiedzialności, z dowolnego powodu, w tym bez ograniczeń, jeśli
                    naruszysz niniejsze Warunki.
                </p>
                <p>Po rozwiązaniu, Twoje prawo do korzystania z Usługi natychmiast wygasa.</p>
            </section>

            <section>
                <h1>Ograniczenie odpowiedzialności</h1>
                <p>
                    Niezależnie od jakichkolwiek szkód, które możesz ponieść za sprawą korzystania z usługi, AGM ani
                    którykolwiek z jego dostawców NIE zobowiązuje się do zapłaty zadośćuczynienia.
                </p>
                <p>
                    W maksymalnym zakresie dozwolonym przez obowiązujące prawo, w żadnym wypadku AGM ani jego dostawcy nie
                    ponoszą odpowiedzialności za jakiekolwiek szczególne, przypadkowe, pośrednie lub wynikowe szkody (w tym,
                    ale nie wyłącznie, szkody z tytułu utraty danych lub inne informacji, w przypadku przerwy w działalności,
                    utraty prywatności wynikającej lub w jakikolwiek sposób związanej z korzystaniem lub niemożnością
                    korzystania z Usługi, oprogramowania i/lub sprzętu strony trzeciej używanego z Usługą, lub inaczej w
                    związku z jakimkolwiek postanowieniem niniejszych Warunków), nawet jeśli AGM lub jakikolwiek dostawca
                    został poinformowany o możliwości wystąpienia takich szkód, a nawet jeśli środek zaradczy nie spełni
                    swojego podstawowego celu.
                </p>
            </section>

            <section>
                <h1>
                    Oświadczenie &quot;TAK JAK JEST&quot; (&quot;AS IS&quot;) i &quot;JAK DOSTĘPNY&quot; (&quot;AS
                    AVAILABLE&quot;)
                </h1>
                <p>
                    Usługa jest świadczona użytkownikowi &quot;TAK JAK JEST&quot; i &quot;W MIARĘ DOSTĘPNOŚCI&quot; oraz ze
                    wszystkimi wadami bez jakiejkolwiek gwarancji. W maksymalnym zakresie dozwolonym przez obowiązujące
                    prawo, AGM, wyraźnie zrzeka się wszelkich gwarancji, wyraźnych, dorozumianych, ustawowych lub innych, w
                    odniesieniu do usługi. Bez ograniczeń powyższego, AGM nie udziela żadnej gwarancji ani zobowiązania i nie
                    składa żadnego rodzaju oświadczeń, że Usługa spełni Twoje wymagania, osiągnie zamierzone wyniki, będzie
                    kompatybilna lub będzie działać z jakimkolwiek innym oprogramowaniem, aplikacjami, systemami lub
                    usługami, będzie działać nieprzerwanie spełniać wszelkie standardy wydajności lub niezawodności lub być
                    wolna od błędów lub że wszelkie błędy lub wady mogą lub będą naprawiane.
                </p>
                <p>
                    Nie ograniczając powyższego, ani AGM, ani żaden z jej dostawców nie składa żadnych oświadczeń ani
                    gwarancji jakiegokolwiek rodzaju, wyraźnych lub dorozumianych:
                    <ul>
                        <li>
                            Co do działania lub dostępności Usługi lub informacji, treści i materiałów lub produktów
                            związanych z Usługą;
                        </li>
                        <li>Że Usługa będzie nieprzerwana lub wolna od błędów;</li>
                        <li>
                            Co do dokładności, wiarygodności lub aktualności jakichkolwiek informacji lub treści
                            dostarczanych za pośrednictwem Usługi;
                        </li>

                        <li>
                            Że Usługa, jej serwery, treść lub wiadomości e-mail wysyłane z lub w imieniu AGM są wolne od
                            wirusów, skryptów, Trojanów, złośliwego oprogramowania lub jakichkolwiek innych szkodliwych
                            elementów.
                        </li>
                    </ul>
                </p>
                <p>
                    Obowiązujące prawo może nie zezwalać na wyłączenie niektórych rodzajów gwarancji lub ograniczeń mających
                    zastosowanie w ustawowych praw konsumenta, więc niektóre lub wszystkie powyższe wyłączenia i ograniczenia
                    mogą nie mieć zastosowania do Ciebie. Jednak w takim przypadku wyłączenia i ograniczenia określone w tej
                    sekcji będą miały zastosowanie w najszerszym zakresie zgodnym z obowiązującym (w Polsce) prawem.
                </p>
            </section>

            <section>
                <h1>Prawo rządowe</h1>
                <p>
                    Niniejsze Warunki i korzystanie z Usługi przez Użytkownika podlegają prawu polskiemu. Korzystanie z
                    Usługi może również podlegać innym przepisom lokalnym, krajowym lub międzynarodowym
                </p>
            </section>

            <section>
                <h1>Rozstrzyganie sporów</h1>
                <p>AGM będzie jedynym arbitrem w ustalaniu naruszeń przepisów określonych w tym regulaminie.</p>
            </section>

            <section>
                <h1>Rozdzielność postanowień</h1>
                <p>
                    Jeśli jakiekolwiek postanowienie niniejszych Warunków zostanie uznane za niewykonalne lub nieważne,
                    postanowienie to zostanie zmienione i zinterpretowane tak, aby osiągnąć cele takiego postanowienia w
                    największym możliwym zakresie zgodnie z obowiązującym prawem, a pozostałe postanowienia pozostaną w
                    pełnej mocy.
                </p>
            </section>

            <section>
                <h1>Interpretacja tłumaczeń</h1>
                <p>
                    Niniejsze Warunki mogły zostać przetłumaczone. Zgadzasz się, że w przypadku sporu pierwszeństwo ma{" "}
                    <a href="https://wiktorgolicz.pl/AirlinesGroupManager/termsPL">oryginalny tekst polski</a>.
                </p>
            </section>

            <section>
                <h1>Zmiany regulaminu</h1>
                <p>
                    Zastrzegamy sobie prawo, według naszego wyłącznego uznania, do modyfikowania lub zastępowania niniejszych
                    Warunków w dowolnym momencie. W przypadku istotnych zmian, będziemy wymagać twej zgody na nowe warunki.
                    Co stanowi istotną zmianę, zostanie ustalone według naszego wyłącznego uznania.
                </p>
                <p>
                    Kontynuując dostęp do naszej Usługi lub korzystanie z niej po wejściu w życie wszelkich zmian, zgadzasz
                    się na związanie się ze zmienionymi warunkami. Jeśli nie zgadzasz się na nowe warunki, w całości lub w
                    części, zaprzestań korzystania z serwisu i Usługi.
                </p>
            </section>

            <section>
                <h1>Prawa autorskie</h1>
                <p>
                    Autorem i administratorem gry i osobą zastrzegającą sobie wszystkie prawa do kodu źródłowego gry jest
                    Wiktor Golicz.
                </p>

                <h2>Mapy</h2>
                <p>
                    Źródła map
                    <ul>
                        <li>
                            Mapa domyślna &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri
                            Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012
                        </li>
                        <li>
                            Mapa jasna &copy;{" "}
                            <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">
                                OpenStreetMap
                            </a>{" "}
                            contributors &copy;{" "}
                            <a href="https://carto.com/attributions" target="_blank" rel="noreferrer">
                                CARTO
                            </a>
                        </li>
                        <li>
                            Mapa ciemna &copy;{" "}
                            <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">
                                OpenStreetMap
                            </a>{" "}
                            contributors &copy;{" "}
                            <a href="https://carto.com/attributions" target="_blank" rel="noreferrer">
                                CARTO
                            </a>
                        </li>
                        <li>
                            Mapa satelitarna Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye,
                            Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community
                        </li>
                    </ul>
                </p>

                <h2>Ikony</h2>
                <p>
                    Źródła ikon:
                    <ul>
                        <li>
                            Ikony będące własnością serwisu{" "}
                            <a href="https://fontawesome.com/" target="_blank" rel="noreferrer">
                                Font Awesome
                            </a>
                        </li>

                        <li>
                            Ikony będące własnością serwisu{" "}
                            <a href="https://fontawesome.com/" target="_blank" rel="noreferrer">
                                Font Awesome
                            </a>{" "}
                            i zmodyfikowane przez autora gry.
                        </li>

                        <li>
                            Ikony samolotów wyświetlane na mapie &copy; Wiktor Golicz &amp; Daniel Moszczowski. Wszelkie
                            prawa zastrzeżone.
                        </li>
                    </ul>
                </p>

                <h2>Grafiki</h2>
                <p>
                    Źródła grafik samolotów:
                    <ul>
                        <li>&copy; Daniel Moszczowski. Wszelkie prawa zastrzeżone.</li>
                        <li>Google images</li>
                    </ul>
                </p>
            </section>

            <section>
                <h1>Kontakt</h1>
                <p>
                    Jeśli masz jakiekolwiek pytania dotyczące niniejszego regulaminu skontaktuj się z nami:{" "}
                    <a href="mailto: regulaminAGM@wiktorgolicz.pl">regulaminAGM@wiktorgolicz.pl</a>
                </p>
            </section>

            <footer>
                <small>Copyright &copy; {new Date().getFullYear()} Wiktor Golicz. Wszelkie prawa zastrzeżone.</small>
            </footer>
        </div>
    );
};

// eslint-disable-next-line
const TermsEn = () => {
    return (
        <div>
            <h1>Terms and Conditions</h1>
            <p>Last updated: July 27, 2022</p>
            <p>Please read these terms and conditions carefully before using the service.</p>
            <h1>Interpretation and Definitions</h1>
            <h2>Interpretation</h2>
            <p>
                The words of which the initial letter is capitalized have meanings defined under the following conditions.
                The following definitions shall have the same meaning regardless of whether they appear in singular or in
                plural.
            </p>
            <h2>Definitions</h2>
            <p>For the purposes of these Terms and Conditions:</p>
            <ul>
                <li>
                    <p>
                        <strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control
                        with a party, where &quot;control&quot; means ownership of 50% or more of the shares, equity interest
                        or other securities entitled to vote for election of directors or other managing authority.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Country</strong> refers to: Poland
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;,
                        &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Airlines Group Manager.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Device</strong> means any device that can access the Service such as a computer, a cellphone
                        or a digital tablet.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Service</strong> refers to the Website.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Terms and Conditions</strong> (also referred as &quot;Terms&quot;) mean these Terms and
                        Conditions that form the entire agreement between You and the Company regarding the use of the
                        Service. This Terms and Conditions agreement has been created with the help of the{" "}
                        <a href="https://www.termsfeed.com/terms-conditions-generator/" rel="noreferrer" target="_blank">
                            TermsFeed Terms and Conditions Generator
                        </a>
                        .
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Third-party Social Media Service</strong> means any services or content (including data,
                        information, products or services) provided by a third-party that may be displayed, included or made
                        available by the Service.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Website</strong> refers to Airlines Group Manager, accessible from{" "}
                        <Link to="/" rel="external nofollow noopener noreferrer" target="_blank">
                            https://wiktorgolicz.pl/AirlinesGroupManager
                        </Link>
                    </p>
                </li>
                <li>
                    <p>
                        <strong>You</strong> means the individual accessing or using the Service, or the company, or other
                        legal entity on behalf of which such individual is accessing or using the Service, as applicable.
                    </p>
                </li>
            </ul>
            <h1>Acknowledgment</h1>
            <p>
                These are the Terms and Conditions governing the use of this Service and the agreement that operates between
                You and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the
                use of the Service.
            </p>
            <p>
                Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms
                and Conditions. These Terms and Conditions apply to all visitors, users and others who access or use the
                Service.
            </p>
            <p>
                By accessing or using the Service You agree to be bound by these Terms and Conditions. If You disagree with
                any part of these Terms and Conditions then You may not access the Service.
            </p>
            <p>
                Your access to and use of the Service is also conditioned on Your acceptance of and compliance with the
                Privacy Policy of the Company. Our Privacy Policy describes Our policies and procedures on the collection,
                use and disclosure of Your personal information when You use the Application or the Website and tells You
                about Your privacy rights and how the law protects You. Please read Our Privacy Policy carefully before using
                Our Service.
            </p>
            <h1>Links to Other Websites</h1>
            <p>
                Our Service may contain links to third-party web sites or services that are not owned or controlled by the
                Company.
            </p>
            <p>
                The Company has no control over, and assumes no responsibility for, the content, privacy policies, or
                practices of any third party web sites or services. You further acknowledge and agree that the Company shall
                not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused
                by or in connection with the use of or reliance on any such content, goods or services available on or
                through any such web sites or services.
            </p>
            <p>
                We strongly advise You to read the terms and conditions and privacy policies of any third-party web sites or
                services that You visit.
            </p>
            <h1>Termination</h1>
            <p>
                We may terminate or suspend Your access immediately, without prior notice or liability, for any reason
                whatsoever, including without limitation if You breach these Terms and Conditions.
            </p>
            <p>Upon termination, Your right to use the Service will cease immediately.</p>
            <h1>Limitation of Liability</h1>
            <p>
                Notwithstanding any damages that You might incur, the entire liability of the Company and any of its
                suppliers under any provision of this Terms and Your exclusive remedy for all of the foregoing shall be
                limited to the amount actually paid by You through the Service or 100 USD if You haven't purchased anything
                through the Service.
            </p>
            <p>
                To the maximum extent permitted by applicable law, in no event shall the Company or its suppliers be liable
                for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to,
                damages for loss of profits, loss of data or other information, for business interruption, for personal
                injury, loss of privacy arising out of or in any way related to the use of or inability to use the Service,
                third-party software and/or third-party hardware used with the Service, or otherwise in connection with any
                provision of this Terms), even if the Company or any supplier has been advised of the possibility of such
                damages and even if the remedy fails of its essential purpose.
            </p>
            <p>
                Some states do not allow the exclusion of implied warranties or limitation of liability for incidental or
                consequential damages, which means that some of the above limitations may not apply. In these states, each
                party's liability will be limited to the greatest extent permitted by law.
            </p>
            <h1>&quot;AS IS&quot; and &quot;AS AVAILABLE&quot; Disclaimer</h1>
            <p>
                The Service is provided to You &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; and with all faults and defects
                without warranty of any kind. To the maximum extent permitted under applicable law, the Company, on its own
                behalf and on behalf of its Affiliates and its and their respective licensors and service providers,
                expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the
                Service, including all implied warranties of merchantability, fitness for a particular purpose, title and
                non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or
                trade practice. Without limitation to the foregoing, the Company provides no warranty or undertaking, and
                makes no representation of any kind that the Service will meet Your requirements, achieve any intended
                results, be compatible or work with any other software, applications, systems or services, operate without
                interruption, meet any performance or reliability standards or be error free or that any errors or defects
                can or will be corrected.
            </p>
            <p>
                Without limiting the foregoing, neither the Company nor any of the company's provider makes any
                representation or warranty of any kind, express or implied: (i) as to the operation or availability of the
                Service, or the information, content, and materials or products included thereon; (ii) that the Service will
                be uninterrupted or error-free; (iii) as to the accuracy, reliability, or currency of any information or
                content provided through the Service; or (iv) that the Service, its servers, the content, or e-mails sent
                from or on behalf of the Company are free of viruses, scripts, trojan horses, worms, malware, timebombs or
                other harmful components.
            </p>
            <p>
                Some jurisdictions do not allow the exclusion of certain types of warranties or limitations on applicable
                statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to You.
                But in such a case the exclusions and limitations set forth in this section shall be applied to the greatest
                extent enforceable under applicable law.
            </p>
            <h1>Governing Law</h1>
            <p>
                The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the
                Service. Your use of the Application may also be subject to other local, state, national, or international
                laws.
            </p>
            <h1>Disputes Resolution</h1>
            <p>
                If You have any concern or dispute about the Service, You agree to first try to resolve the dispute
                informally by contacting the Company.
            </p>
            <h1>For European Union (EU) Users</h1>
            <p>
                If You are a European Union consumer, you will benefit from any mandatory provisions of the law of the
                country in which you are resident in.
            </p>
            <h1>United States Legal Compliance</h1>
            <p>
                You represent and warrant that (i) You are not located in a country that is subject to the United States
                government embargo, or that has been designated by the United States government as a &quot;terrorist
                supporting&quot; country, and (ii) You are not listed on any United States government list of prohibited or
                restricted parties.
            </p>
            <h1>Severability and Waiver</h1>
            <h2>Severability</h2>
            <p>
                If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and
                interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable
                law and the remaining provisions will continue in full force and effect.
            </p>
            <h2>Waiver</h2>
            <p>
                Except as provided herein, the failure to exercise a right or to require performance of an obligation under
                these Terms shall not effect a party's ability to exercise such right or require such performance at any time
                thereafter nor shall the waiver of a breach constitute a waiver of any subsequent breach.
            </p>
            <h1>Translation Interpretation</h1>
            <p>
                These Terms and Conditions may have been translated if We have made them available to You on our Service. You
                agree that the original Polish text shall prevail in the case of a dispute.
            </p>
            <h1>Changes to These Terms and Conditions</h1>
            <p>
                We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. If a revision is
                material We will make reasonable efforts to provide at least 30 days' notice prior to any new terms taking
                effect. What constitutes a material change will be determined at Our sole discretion.
            </p>
            <p>
                By continuing to access or use Our Service after those revisions become effective, You agree to be bound by
                the revised terms. If You do not agree to the new terms, in whole or in part, please stop using the website
                and the Service.
            </p>
            <h1>Contact Us</h1>
            <p>If you have any questions about these Terms and Conditions, You can contact us:</p>
            <ul>
                <li>By email: agm@wiktorgolicz.pl</li>
            </ul>

            <footer>
                <small>Copyright &copy; {new Date().getFullYear()} Wiktor Golicz. All rights reserved.</small>
            </footer>
        </div>
    );
};

const EnglishUnavailable = () => {
    return (
        <div>
            Currently, the English version of the Terms and Conditions is unavailable. You can view the original Polish
            version <Link to="/termsPL">here</Link>
        </div>
    );
};

export default Terms;
